import { render, staticRenderFns } from "./EditAlertFile.vue?vue&type=template&id=af1ef75e&"
import script from "./EditAlertFile.vue?vue&type=script&lang=js&"
export * from "./EditAlertFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports